import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createNewMenu } from "../../../store/Menu/api";
import {useHistory} from "react-router";
import { restaurantSaveDetails, storeAdd } from '../../../store/Restaurant/api';
import { toast } from 'react-toastify';

export const useAddNewStore = () => {
    const history = useHistory();
    const queryClient = useQueryClient();

    return useMutation(['addNewStore'], ({ params }) => storeAdd(params), {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['stores']);
            history.push(`/chain/stores`)
        },
        onError: (error) => {
            toast.error(error.response?.data?.message)
        }
    });
};
